import { Injectable } from "@angular/core";
import { CanActivate, CanActivateChild, Router } from "@angular/router";
import { CoginitoIdentityDataService } from "../coginito-identity-data/coginito-identity-data.service";
import { BilDashboardService } from "@app/home/service/bil-dashboard.service";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private coginitoIdentityDataService: CoginitoIdentityDataService,
    private router: Router,
    private bilDashboardService: BilDashboardService
  ) {}

  canActivate() {
    if (this.coginitoIdentityDataService.getAuthToken()) {
      return this.bilDashboardService.getApplicationData().pipe(
        map((response: any) => {
          console.log(response)
          if (response.data.applications.length) {
            localStorage.removeItem("campaign");
            return true;
          } else {
            if (localStorage.getItem("campaign") === "b2c") {
              localStorage.clear();
              this.router.navigate(["/registration/register"], {
                queryParams: { B2C: "true" },
              });
            } else {
              this.router.navigate(["/bil/requirement"]);
            }
            return false;
          }
        })
      );
    } else {
      this.router.navigate(["/registration"]);
      return false;
    }
  }
}
